import React, { useEffect, useState } from "react";
import { Box } from "@mui/material";
import { DateTime } from "luxon";

import {  useSelector } from "react-redux";
import {
  CollapsibleTable,
  ColumnName,
} from "../../../components/molecules/CollapsableTable.tsx";
import { padding } from "../../../theme.ts";
import { useQueryBackend } from "../../../utils/requestHelpers.ts";
import { compareVersions } from "./softwareVersionUtils.ts";
import { SubpageTitle } from "../../../components/atoms/text/titles.tsx";

interface SoftwareVersionItem {
  softwareVersion: string
  versionDescription: string | undefined
  softwareType: string
  fromDate: string
  deviceId: string
  serialNumber: string
  machineName?: string
}

export const MachineSoftwareVersionTable = ({seeAllMachines}:{seeAllMachines?: boolean}) => {
  const isMobile = useSelector(
    (state: any) => state.dimensions.device === "mobile"
  );

  const queryApi = useQueryBackend("Backoffice");

  const columnNames: ColumnName[] = [
    {
      displayName: "Version",
      id: "softwareVersion",
      aggregate: false,
      grouped: true,
      level: 0, 
      align: "left",
      visible: true,
    },
    {
      displayName: "Amount",
      id: "machineName",
      aggregate: false,
      grouped: false,
      level: 1, 
      align: "left",
      visible: true, 
      formatter: (value: string) => value?.toString(),
      altText: (row, agg, level) => {
        if(level === 0){
            return (
              <div style={{
                position:"relative", 
                display:"inline-block", 
                minWidth: '50px', 
                textAlign: 'right',
              }}>{row.items.length}
                <span style={{
                  position: 'absolute',
                  left: '100%',
                  top: '0',
                  maxWidth: '450px',
                  overflow: 'hidden',
                  textOverflow: 'ellipsis',
                  textAlign: 'left',
                  whiteSpace: 'nowrap',
                  marginLeft: '50px',

                }}
                title={row.items[0]['versionDescription']}
                >{row.items[0]['versionDescription']}</span>
              </div>)
        }
        return level
      }
    },
    {
      displayName: "Device Id",
      id: "deviceId",
      aggregate: false,
      grouped: false,
      level: 1,
      align: "left",
      visible: true, 
      altText: (row, agg, level) => {
        if(level === 0){
            return ""
        }
        return level
        }
    },
    {
      displayName: "Updated At",
      id: "fromDate",
      aggregate: false,
      grouped: false,
      level: 1, 
      align: "left",
      visible: true,
      altText: (row, agg, level) => {
        if(level === 0){
            return ""
        }
        return level
        }
    },
    {
      displayName: "Serial No",
      id: "serialNumber",
      aggregate: false,
      grouped: false,
      level: 1,
      align: "left",
      visible: true,
      altText: (row, agg, level) => {
        if(level === 0){
            return ""
        }
        return level
        }
    },
    {
      displayName: "Type",
      id: "softwareType",
      aggregate: false,
      grouped: false,
      level: 1, // No grouping at this level
      align: "left",
      visible: true, 
      altText: (row, agg, level) => {
        if(level === 0){
            return ""
        }
        return level
        }
    }
  ];

  const [data, setData] = useState<Array<SoftwareVersionItem>>([]);


  useEffect(() => {
    queryApi
      .Get<Array<SoftwareVersionItem>>(
        `software-versions/at-${DateTime.now().toFormat("yyyy-MM-dd")}
        ${seeAllMachines ?  "" : "?param=onlyActivated"}`
      )
      .Data((d) => {
        setData(d);
      });
  }, [seeAllMachines]);

  const prepData = [...data];

  const sortedData = prepData.sort(compareVersions).reverse();

  return (
      <Box sx={[isMobile && { marginBottom: padding / 2 }]}>
        <SubpageTitle title={"Software versions today"} />
        <CollapsibleTable
          columnNames={columnNames}
          rows={sortedData} 
        ></CollapsibleTable>
      </Box>
  );
};
